import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import CopyLogo from "../../../../assets/images/onboardingImages/logo_black.svg";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import Modal from "react-bootstrap/Modal";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { fetchUser } from "../../../../helpers/helper";
import { useSelector, useDispatch } from "react-redux";
import { resetOnBoardingStartContext, storeUser } from "../../../../redux/users/usersSlice";
import CloseModal from "../../OnboardingCL/CreateSubscription/CloseModal";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const Verify = () => {
  const [warn, setWarn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const onBoardingStartContext=useSelector(state=>state.user?.onBoardingStartContext);

  const [show, setShow] = useState(true);
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;
  const api = useApi();
  const navigate = useNavigate();

  const handleClose = () => {
    if(onBoardingStartContext){
      setShow(false);
      dispatch(resetOnBoardingStartContext()); 
      navigate(onBoardingStartContext,{replace:true});
      return;
    }
    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };

  const handleVerify = async () => {
    if (!otp || otp.length < 6) return toastify("Invalid code", "error");

    setIsLoading(true);

    try {
      const response = await api(
        "post",
        "authorizeNewonBoard/verifyAccountOTP",
        {
          otp,
          onboarding: {
            community: [
              {
                id: user?.leaderCommunity?._id,
                message: "On boarding complete",
              },
            ],
            isVerified: true,
          },
          firstVisit: false,
          // "onboarding.subscribed": false,
          // "onboarding.connect": false,
          // "onboarding.payment": false,
          // "onboarding.isCommunityCreated": false,
        }
      );

      if (response?.data?.verified) {
        showNotificationToast("Email verified!");
        if (user?.socialLogin?.discord?.id || user?.socialLogin?.telegram?.id) {
          navigate("/leader/onboarding/setupComplete", { replace: true, state: { from: "onboarding" } });
          return;
        }
        navigate("/leader/onboarding/alldone", { replace: true, state: { from: "onboarding" } });
      } else {
        toastify("Invalid code", "error");
        setOtp("");
      }
    } catch (error) {
      console.error("🚀 -> handleVerify -> error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const sendOtp = async () => {
    setIsLoading(true);

    try {
      const response = await api("post", "authorizeNewonBoard/sendOtp");

      if (response?.status) toastify(response?.message);
      else toastify(response?.message, "error");
    } catch (error) {
      console.error("🚀 -> sendOtp -> error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(()=>{
    if((isOnBoardingComplete&&user?.leaderCommunity)||(!user?.leaderCommunity)){
      navigate("/leader/dashboard", { replace: true });
      return;
     }
  
    if(!isOnBoardingComplete&&user?.leaderCommunity){
      if(!user?.onboarding?.connect){
        navigate("/leader/onboarding/connection", { replace: true });
        return;
      }
      if(!user?.onboarding?.subscribed){
        navigate("/leader/onboarding/subscription", { replace: true });
        return;
      }
      if(!user?.onboarding?.payment){
        navigate("/leader/onboarding/payout", { replace: true });
        return;
      }
    }
  },[])

  // useEffect(() => {
  //   if (user?.role === "leader") {
  //     if (!user?.onboarding?.isCommunityCreated) {
  //       navigate("/leader/onboarding/community", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.connect) {
  //       navigate("/leader/onboarding/connection", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.subscribed) {
  //       navigate("/leader/onboarding/subscription", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.payment) {
  //       navigate("/leader/onboarding/payout", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.isVerified) {
  //       navigate("/leader/onboarding/verify", { replace: true });
  //       return;
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (otp.length === 6) handleVerify();
    if (otp.length > 6) {
      toastify("Invalid code", "error");
      setOtp("");
    }
  }, [otp]);
 
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal"
        show={show}
      >
        <Modal.Body className="figma-drop-shadow">
          <button
            className="reverseArrow"
            onClick={() =>
              navigate("/leader/onboarding/payout", { replace: true })
            }
            type="button"
          >
            <img src={Arrow} alt="" />
          </button>

          <button type="button" className="CrossIcon" onClick={handleClose}>
            <img src={Cross} alt="" />
          </button>
          <div className="onboardingContentBox top73px">
            <h2 className="title">
              <span>Verify email</span>
            </h2>
            <p className="desc bottom50px">
            Please use the code sent to your email.
            </p>
            <div className="formBox">
              <div className="mb-20px">
                <FloatingTextFiled
                  className="onboardingInput"
                  label="Enter code from email"
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter code form email"
                  type="number"
                  value={otp}
                />
              </div>

              <div>
                <BubbleSvgButton
                  className="NextBtn"
                  onClick={handleVerify}
                  disabled={isLoading}
                  text={"Next"}
                  type="button"
                  variant="black"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                  mainDivStyle={{
                    width: "275px",
                    height: "55px",
                  }}
                />
              </div>

              <button
                className="resendBtn"
                disabled={isLoading}
                onClick={sendOtp}
                type="button"
              >
                Resend Code
              </button>
            </div>
          </div>

          <div className="paginationDots">
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className={`dot active`}></button>
            <button className={`dot`}></button>
          </div>
          <div className="copyrightBox">
            <p className="">
              Powered by{" "}
              <span className="spanMain">
                <img src={CopyLogo} alt="" />
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>

      {warn && (
        <CloseModal handleClose={handleClose} setWarn={setWarn} warn={warn} />
      )}
    </div>
  );
};

export default Verify;
